import Vue from 'vue';
import CountryFlag from 'vue-country-flag';

Vue.use(CountryFlag);

export default CountryFlag;
